







































import { Component, Vue, Prop } from "vue-property-decorator";
import { HOST } from "../global";
import {
  TweenMax,
  TimelineLite,
  Power3,
  Power4,
  Power1,
  Expo,
  Power2,
  TimelineMax,
} from "gsap";
import ScrollMagic from "scrollmagic";
import gsap from "scrollmagic";

@Component({
  name: "OppertunityCard",
})
export default class OppertunityCard extends Vue {
  @Prop() readonly compData!: any;
  public HOST: string = HOST;
  public oppcardAnim() {
    var optext = document.querySelectorAll(".sq-h-content");
    var logoanim = document.querySelectorAll(".sq-logo-bg");
    var optimg = document.querySelectorAll(".opcard-img img");
    const controller1 = new ScrollMagic.Controller();
    optext.forEach((opt) => {
      const optanim = new TimelineMax().from(opt, 1, {
        yPercent: 40,
        autoAlpha: 0,
        ease: Power2.easeOut,
        clearProps: "all",
      });

      const scene1 = new ScrollMagic.Scene({
        triggerElement: opt,
        reverse: false,
      })
        .setTween(optanim)
        .addTo(controller1);
    });

    //  animation3
    const controller2 = new ScrollMagic.Controller();

    logoanim.forEach((sqlogo) => {
      const lg = new TimelineMax().from(
        sqlogo,
        1,
        {
          autoAlpha: 0,
          width: 0,
          yPercent: 20,
          ease: Power2.easeOut,
          clearProps: "all",
        },
        "+=.4"
      );

      const scene2 = new ScrollMagic.Scene({
        triggerElement: sqlogo,
        reverse: false,
      })
        .setTween(lg)
        .addTo(controller2);
    });

    //  animation3
    const controller3 = new ScrollMagic.Controller();

    optimg.forEach((oimg) => {
      const opimage = new TimelineMax().from(oimg, 1.2, {
        xPercent: 40,
        autoAlpha: 0,
        ease: Power2.easeOut,
        clearProps: "all",
      });

      const scene3 = new ScrollMagic.Scene({
        triggerElement: oimg,
        reverse: false,
      })
        .setTween(opimage)
        .addTo(controller3);
    });
  }
  public mounted() {
    if (window.matchMedia("(min-width: 1025px)").matches) {
        this.oppcardAnim();
       }

   
  }
}
